function changeActiveFilterSlide(carousel) {
  const swiperWrapper = document.querySelector(
    '.filters-carousel .facetwp-facet'
  );
  const filtersRadio = document.querySelectorAll('.facetwp-radio');

  filtersRadio.forEach((radioBtn) => {
    radioBtn.addEventListener('click', function () {
      let radioBtnIndex = Array.prototype.indexOf.call(
        swiperWrapper.children,
        radioBtn
      );
      carousel.slideTo(radioBtnIndex);
    });
  });
}

window.addEventListener('load', function () {
  const Swiper = window.Swiper;
  const filters = document.querySelector('.filters-header .filters-carousel');

  if (filters) {
    const filtersCarousel = new Swiper('.filters-header .filters-carousel', {
      wrapperClass: 'facetwp-facet',
      direction: 'horizontal',
      loop: false,
      slidesPerView: 'auto',
      slideClass: 'facetwp-radio',
      watchOverflow: true,
    });

    changeActiveFilterSlide(filtersCarousel);

    window.addEventListener('facetwp-loaded', function () {
      changeActiveFilterSlide(filtersCarousel);
    });
  }
});
